import React from "react";
import MUITextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import AutocompleteField from './AutocompleteField';
import CheckboxField from "./CheckboxField";
import ConfirmationCode from "./ConfirmationCodeField";
import DateTimeField from "./DateTimeField";
import NumberField from "./NumberField";
import PhoneField from "./PhoneField";
import RoutePointField from "./RoutePointField";
import PaymentTypeField from "./PaymentTypeField";
import ToogleButtonField from "./ToogleButtonField";
import VehicleTypeField from "./VehicleTypeField";

export const FormTextField = React.memo((
  {
    label,
    input,
    meta: { touched, invalid, error },
    ...custom
  }) => (
  <MUITextField
    label={label}
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
  />
));

export const FormNumberField = React.memo((
  {
    label,
    input,
    meta: { touched, invalid, error },
    ...custom
  }) => (
  <NumberField
    label={label}
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
  />
));

export const FormPhoneField = React.memo((
  {
    label,
    input,
    meta,
    ...custom
  }) => <PhoneField
    label={label}
    {...input}
    touched={meta.touched}
    invalid={meta.invalid}
    helperText={meta.error}
    {...custom}
  />,
);

export const FormDateTimeField = React.memo((
  {
    label,
    disabled,
    input,
    meta: { touched, invalid, error },
    ...custom
  }) => {
  return (
    <DateTimeField
      value={input.value}
      label={label}
      disabled={disabled}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      onChange={(value) => {
        input.onChange(value || 0);
      }}
      onBlur={()=>{
        input.onBlur(input?.value || 0);
      }}
      {...custom}
    />
  );
});

export const FormRoutePointField = React.memo((
  {
    label,
    input,
    airport,
    meta: { touched, invalid, error },
    ...custom
  }) => {
  return (
    <RoutePointField
      value={input.value}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      onChange={(value) => input.onChange(value)}
      onBlur={() => input.onBlur(input.value)}
      {...custom}
    />
  );
});

export const FormVehicleTypeField = React.memo((
  {
    input,
    options,
    ...custom
  }) => {
    return <VehicleTypeField
      options={options}
      value={input.value}
      onChange={(value) => {
        input.onChange(value);
      }}
      {...input}
      {...custom}
    />;
  },
);

export const FormPaymentTypeField = React.memo((
  {
    input,
    ...custom
  }) => {
    return <PaymentTypeField
      value={input.value}
      {...input}
      {...custom}
    />;
  },
);

export const FormCheckboxField = React.memo((
  {
    label,
    input,
    ...custom
  }) => {
  return (
    <CheckboxField
      label={label}
      {...input}
      {...custom}
    />
  );
});

export const FormToogleButtonField = React.memo((
  {
    label,
    input,
    ...custom
  }) => {
  return (
    <ToogleButtonField
      label={label}
      {...input}
      {...custom}
    />
  );
});


export const FormConfirmationCodeField = React.memo((
  {
    input,
    disabled,
    ...custom
  }) => {
  return (
    <ConfirmationCode
      value={input.value}
      disabled={disabled}
      onChange={(value) => {
        input.onChange(value);
      }}
      {...input}
      {...custom}
    />
  );
});



export const FormAutocompleteField = React.memo((
  {
    input,
    meta: { touched, invalid, error },
    ...custom
  }) => {
    return <AutocompleteField
      {...input}
      error={touched && invalid}
      helperText={touched && error}
      value={input.value}
      onChange={(e, value) => {
        input.onChange(value);
      }}
      {...custom}
    />;
  }
);

export const FormAccountField = React.memo((
  {
    label,
    input,
    options = [],
    meta: { touched, invalid, error },
    ...custom
  }) => (
  <MUITextField
    select
    fullWidth
    variant="outlined"
    label={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    value={input.value?.id ?? ""}
    onChange={(e) => input.onChange(options.find(({ id }) => id === e.target.value))}
    onBlur={() => input.onBlur(input.value)}
    {...custom}
  >
    {options.map(({ id, name }) => (
      <MenuItem key={id} value={id}>{name}</MenuItem>
    ))}
  </MUITextField>
));
